"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as l } from "react";
import r from "../components/Icon/SvgIcon.js";
const t = (e) => /* @__PURE__ */ o(
  r,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...e,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13.138 2c-4.152 0-7.53 3.203-7.53 7.138 0 2.168 1.028 4.109 2.642 5.419l-4.652 6.14a.443.443 0 0 0 .09.642l.855.582a.5.5 0 0 0 .67-.125l4.708-6.214c.977.44 2.065.694 3.217.694 4.152 0 7.529-3.202 7.529-7.138S17.289 2 13.137 2m0 12.572c-3.16 0-5.732-2.437-5.732-5.434 0-2.996 2.571-5.433 5.732-5.433s5.731 2.437 5.731 5.433-2.57 5.434-5.731 5.434",
        clipRule: "evenodd"
      }
    )
  }
), n = l(t);
export {
  n as Search,
  n as default
};
